import { Team } from '@basehub/data/replicache/index'
import { useTeamReplicache } from './use-team-replicache'
import { useActivePublicTeam } from './team/use-active-public-team'
import {
  PublicTeam,
  isPublicTeam,
} from '@basehub/data/replicache/mutators/_public-types'

export const useSelectedTeam = (staticData?: PublicTeam | Team) => {
  // `isLoading` will give true even when replicache query is disabled
  const { data: teamReplicache, isLoading: isLoadingTeam } = useTeamReplicache()
  const { data: activePublicData, isInitialLoading: isLoadingPublic } =
    useActivePublicTeam()

  return {
    isLoading: staticData ? false : isLoadingTeam || isLoadingPublic,
    team: staticData ?? teamReplicache?.team ?? activePublicData?.team ?? null,
  } as
    | { isLoading: false; team: Team | PublicTeam | null }
    | { isLoading: true; team: null }
}

/** Returns the selected team, but throws an error if it's a public team. */
export const useSafeSelectedTeam = ():
  | { isLoading: false; team: Team | null }
  | { isLoading: true; team: null } => {
  const { team, ...rest } = useSelectedTeam()
  if (team && isPublicTeam(team)) {
    console.error('Expected a private team')
    return { team: null, ...rest }
  }

  return { team, ...rest } as
    | { isLoading: false; team: Team | null }
    | { isLoading: true; team: null }
}
